import React, { createContext, useMemo } from 'react';
import { useValueRef } from '../../../../../../hooks/useValueRef';

export const ModalPropsContext = createContext();

export const ModalPropsProvider = ({ children, reset }) => {
  const resetRef = useValueRef(reset);

  const props = useMemo(() => {
    return {
      title: 'Установить одностороннюю передачу',
      afterClose: resetRef.current,
    };
  }, [resetRef]);

  return (
    <ModalPropsContext.Provider value={props}>
      {children}
    </ModalPropsContext.Provider>
  );
};
